import type { CaseStudyCategory } from "../CaseStudyCategory.js";
import type { Locale } from "../Locale.js";
import { caseStudyCategoryUrlMap } from "../names/caseStudyCategoryUrlMap.js";
import { referencesPathMap } from "./referencesPathMap.js";

export function getReferencesInReferenceCategoryPath(category: CaseStudyCategory, locale: Locale): string {
	return `${referencesPathMap[locale]}/${caseStudyCategoryUrlMap[category][locale]}`;
}
